import React, { useState, useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";

// hooks
import { useSettingsTabs } from "@/hooks/useSettingsTabs";

// In house icons
import { Search } from "@/components/icons_new";

// Tab navigation config
// Used to render each navigation tab and route under settings
const tabs = [
  { name: "Business & Account", path: "business-account" },
  { name: "Staff Settings", path: "staff-settings" },
  { name: "Website & Domain", path: "website-domain" },
  { name: "Orders & Checkout", path: "orders-checkout" },
  { name: "Subscription Plans", path: "subscription-plans" },
  { name: "Payments & Billing", path: "payments-billing" }
];

export default function AccountSettings() {
  const [search, setSearch] = useState("");
  const tabs = useSettingsTabs();

  // Filter the list of tabs using the search input
  const filteredTabs = tabs.filter((tab) =>
    tab.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
      <div className="bg-white flex h-[90%] w-full border rounded-md border-[#c4c4c4] flex-col lg:flex-row">
          {/* Tabs (Left sidebar for desktop) */}
          <aside className="w-full lg:w-[340px] shrink-0 border-b border-[#c4c4c4] p-4 dark:border-white/10 lg:border-b-0 lg:border-r lg:max-h-[calc(100vh-200px)] lg:overflow-y-auto">
            {/* Settings search bar */}
            <div className="flex flex-row gap-[4px] border border-[#c7c7c7] rounded-md items-center mb-4 px-2 shadow-sm focus-within:border-brand-500 focus-within:ring-1 focus:ring-brand-500 dark:border-white/10">
              <Search className="w-6 h-6"/>
              <input
                type="text"
                placeholder="Search settings..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full  bg-white px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none dark:bg-navy-800 dark:text-white dark:placeholder-white/40"
              />
            </div>
            
            {/* Setting tab */}
            <nav className="flex flex-row gap-2 overflow-x-auto lg:flex-col lg:overflow-x-visible">
              {filteredTabs.map((tab) => (
                <NavLink
                  key={tab.path}
                  to={tab.path}
                  className={({ isActive }) =>
                    `whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition ${
                      isActive
                        ? "bg-[#1100EF] text-white font-semibold"
                        : "text-[#000] hover:bg-[#f1f0ff] hover:text-[#000] dark:text-white dark:hover:bg-white/10"
                    }`
                  }
                >
                  {tab.name}
                </NavLink>
              ))}
            </nav>
          </aside>
            
          {/* Active tab content */}
          <section className="flex-1 overflow-y-auto p-4 md:pr-2 min-h-[75vh] max-h-[calc(100vh-200px)]">
            <Outlet />
          </section>
      </div>
  );
};